import styled from 'styled-components';

interface AnimatedWrapperProps {
  isHidden?: boolean;
}
export default styled.div<AnimatedWrapperProps>`
  margin: 42px 0px 18px 0px;
  visibility: ${props => (props.isHidden ? 'hidden' : 'visible')};
  opacity: ${props => (props.isHidden ? 0 : 1)};
`;
